import { SxProps } from '@mui/material'
import StylesCategoriesServiceInterface from '~/src/pages/categories/styles/StylesCategoriesServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesCategoriesServiceStyleOne extends TemplateServiceStyleBase implements StylesCategoriesServiceInterface {
  public getPageSx(): SxProps {
    return {}
  }
}
